import { css } from 'linaria';

export const cabinetBenefitsGrid = css`
  display: grid;
  padding: 0;
  margin: 0;
  column-gap: 24px;
  list-style: none;

  grid-template-columns: repeat(4, 1fr);

  @media (--to-desktop) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    row-gap: 24px;
  }

  @media (--only-mobile) {
    column-gap: 12px;
    row-gap: 12px;
  }
`;

export const cabinetBenefitsItem = css`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 24px 20px;
  font-family: inherit;
  text-align: left;
  background-color: var(--background-secondary);
  border: none;
  border-radius: var(--rounding-m);
  cursor: pointer;
  row-gap: 32px;

  &:hover {
    background-color: var(--control-minor);
  }

  @media (--only-mobile) {
    padding: 16px 12px;
  }
`;

export const cabinetBenefitsItemImage = css`
  width: 36px;
  height: 36px;

  @media (--only-mobile) {
    position: absolute;
    top: 16px;
    left: 12px;
  }
`;

export const cabinetBenefitsItemContent = css`
  display: flex;
  justify-content: space-between;
  width: 100%;

  @media (--only-mobile) {
    flex-direction: column-reverse;
    row-gap: 8px;
    align-items: flex-end;
  }
`;

export const cabinetBenefitsItemText = css`
  @media (--from-tablet) {
    white-space: break-spaces;
  }

  @media (--only-mobile) {
    width: 100%;
  }
`;

export const cabinetBenefitsItemIconWrapper = css`
  display: flex;
  align-items: center;
  justify-content: center;
  height: max-content;
  padding: 5px;

  @media (--only-mobile) {
    padding: 8px 4px;
  }
`;

export const cabinetBenefitsItemIcon = css`
  && {
    @media (--only-mobile) {
      width: 16px;
      height: 16px;
    }
  }
`;

export const cabinetBenefitsModal = css`
  && {
    @media (--only-tablet) {
      max-width: 480px;
    }
  }
`;

export const cabinetBenefitsModalTitle = css`
  @media (--only-mobile) {
    text-align: center;
  }
`;

export const cabinetBenefitsModalContent = css`
  && {
    padding-bottom: 40px;
  }
`;

export const cabinetBenefitsModalText = css`
  margin-bottom: 8px;
`;

export const cabinetBenefitsModalList = css`
  && {
    margin-bottom: 8px;

    li:not(:last-of-type) {
      margin-bottom: 4px;
    }
  }
`;
